module.exports = __webpack_public_path__ + "img/skip-start-btn-fill.828b53df.svg";